import { useMemo, useState } from 'react';
import {
  FILTER_BY_OPTIONS,
  getActiveFilterMeta,
  getFilterByDropdownOptions,
  getLocationOptionsFromRows,
} from '../constants/hierarchyFilters';

export function useHierarchyFilters(sourceRows = []) {
  const [filterByField, setFilterByField] = useState('');
  const [locationFilter, setLocationFilter] = useState('');

  const activeFilterMeta = useMemo(
    () => getActiveFilterMeta(filterByField),
    [filterByField],
  );

  const locationOptions = useMemo(
    () => getLocationOptionsFromRows(sourceRows, activeFilterMeta.field),
    [sourceRows, activeFilterMeta.field],
  );

  const filterByDropdownOptions = useMemo(() => getFilterByDropdownOptions(), []);

  const locationDropdownOptions = useMemo(
    () => [
      { value: '', label: activeFilterMeta.allLabel },
      ...locationOptions.map((d) => ({ value: d, label: d })),
    ],
    [locationOptions, activeFilterMeta.allLabel],
  );

  const onFilterByChange = (next) => {
    setFilterByField(next ?? '');
    setLocationFilter('');
  };

  const resetHierarchy = () => {
    setFilterByField('');
    setLocationFilter('');
  };

  return {
    filterByField,
    locationFilter,
    setLocationFilter,
    activeFilterMeta,
    filterByDropdownOptions,
    locationDropdownOptions,
    locationPlaceholder: activeFilterMeta.allLabel,
    onFilterByChange,
    resetHierarchy,
  };
}

export { FILTER_BY_OPTIONS };
